import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface FetcherParams {
  clientId: string;
  stepId?: string;
}

export enum TaxEstimationMode {
  Automatic,
  UseEffectiveTaxRate,
}

export enum LocalTaxMode {
  No,
  PercentageOfIncome,
  PercentageOfStateTax,
  FlatAmount,
  NewYorkCityBrackets,
}

enum TaxFilingStatus {
  Individual,
  HeadOfHousehold,
  MarriedFilingJointly,
  MarriedFilingSeparate,
}

export interface DeductibleExpense {
  name: string;
  amount: number | null;
  postRetirementAmount: number | null;
  defaultAmount: number | null;
  defaultPostRetirementAmount: number | null;
  isPrepopulatedField: boolean;
  isCustom: boolean;
}

export interface TaxesDTO {
  canUseEffectiveTaxRateOnly: boolean;
  filingStateOptions: { label: string; value: number; IsInsideUS: boolean }[];
  filingStatusOptions: { label: string; value: TaxFilingStatus }[];
  localTaxModeOptions: { label: string; value: LocalTaxMode }[];
  postRetirementLocalTaxOptions: { label: string; value: LocalTaxMode }[];

  taxEstimationMode: TaxEstimationMode;
  effectiveTaxRate: number;

  useDifferentPostRetirementTaxes: boolean;
  postRetirementtaxEstimationMode: TaxEstimationMode;
  postRetirementEffectiveTaxRate: number;
  postRetirementSelectedFilingState: number;

  localTaxMode: LocalTaxMode;
  flatLocalTax: number;
  percentageLocalTax: number;
  postRetirementLocalTaxMode: LocalTaxMode;
  postRetirementFlatLocalTax: number;
  postRetirementPercentageLocalTax: number;

  useStandardDeductions: boolean;
  itemizedDeductibleExpenses: DeductibleExpense[];
}

const fetchTaxes = async ({ clientId, stepId }: FetcherParams): Promise<TaxesDTO> => {
  return authFetch(
    urlWithParams('/Consumer/TaxFilingStep', {
      clientId,
      stepId,
    }),
  );
};

interface QueryParams {
  clientId: string;
  stepId?: string;
}

export const useTaxesQuery = ({ clientId, stepId }: QueryParams) => {
  return useQuery(
    queryKeys.taxes(clientId, stepId),

    () => fetchTaxes({ clientId, stepId }),

    {
      cacheTime: 0,
    },
  );
};
